module.exports = __webpack_public_path__ + "img/search.86f9b156.svg";